<template>
    <section>
        <div v-if="!single" class="is-relative">
            <h3 class="stepper__content__header">{{ $t('RISK_FACTORS') }}</h3>
        </div>

        <steps v-if="!single" :activeStep="6" :steps="10" class="text-xs-center mb-4"></steps>

        <div class="content__wrapper flex-center">
            <h4 class="stepper__content__title">
                {{ $t('CANCER_AMONG_FAMILY_BEFORE') }}
            </h4>

            <div class="flex-center flex-row mt-3">
                <label class="fake-label">
                    <input class="custom-input" type="radio" value="YES" name="radio" v-model="s3q5Val" />
                    <span class="input-container">{{ $t('YES') }}</span>
                    <span class="checkmark"></span>
                </label>
                <label class="fake-label">
                    <input class="custom-input" type="radio" value="NO" name="radio" v-model="s3q5Val" />
                    <span class="input-container">{{ $t('NO') }}</span>
                    <span class="checkmark"></span>
                </label>
                <label class="fake-label">
                    <input class="custom-input" type="radio" value="I_DO_NOT_KNOW" name="radio" v-model="s3q5Val" />
                    <span class="input-container">{{ $t('I_DO_NOT_KNOW') }}</span>
                    <span class="checkmark"></span>
                </label>
            </div>

            <div class="text-center">
                <div v-if="single">
                    <button @click.stop="cancel()" class="w160 mr-3 app-btn app-btn--small app-btn-default mt-3">
                        {{ $t('CANCEL') }}
                    </button>
                    <button
                        v-if="s3q5Val"
                        @click.stop="save()"
                        class="w160 mr-3 app-btn app-btn--small app-btn-primary mt-3"
                    >
                        {{ $t('SAVE') }}
                    </button>

                    <button v-if="!s3q5Val" class="w160 mr-3 app-btn app-btn--small mt-3" style="opacity: 0.5   ">
                        {{ $t('SAVE') }}
                    </button>
                </div>

                <div v-else>
                    <button @click.stop="goTo(5)" class="w160 mr-3 app-btn app-btn--small app-btn-default mt-3">
                        {{ $t('PREVIOUS') }}
                    </button>
                    <button
                        v-if="s3q5Val"
                        @click.stop="goTo(7)"
                        class="w160 mr-3 app-btn app-btn--small app-btn-primary mt-3"
                    >
                        {{ $t('NEXT') }}
                    </button>

                    <button v-if="!s3q5Val" class="w160 mr-3 app-btn app-btn--small mt-3" style="opacity: 0.5   ">
                        {{ $t('NEXT') }}
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Steps from './helpers/steps.vue';

export default {
    mounted() {
        this.s3q5Val = this.$store.getters.survey.section3.q5_before;
    },
    name: 'survey-step3-q5',
    props: {
        s3q5: String,
        single: Boolean,
    },
    data() {
        return {
            s3q5Val: this.q5,
        };
    },
    computed: {
        q5() {
            return this.$store.getters.survey.section3.q5_before;
        },
    },
    methods: {
        goTo(id) {
            this.$store.commit('STATE_SURVEY', {
                section3: {
                    ...this.$store.getters.survey.section3,
                    active_section: id,
                    q5_before: this.s3q5Val,
                },
            });
        },
        cancel() {
            this.$emit('cancel');
        },
        save() {
            this.$store.commit('STATE_SURVEY', {
                section3: {
                    ...this.$store.getters.survey.section3,
                    q5_before: this.s3q5Val,
                },
            });
            this.$emit('save');
        },
    },
    components: {
        Steps,
    },
};
</script>



// WEBPACK FOOTER //
// survey-step3-q5.vue?55cf5804